






































































import { Component, Watch } from 'vue-property-decorator';
import Mixin from '@/mixin';
import { Table, TableHeader, User } from '@/store/models';
import VPaginationBar from '@/components/items/VPaginationBar.vue';
import VModalManagerItem from '@/components/popup/VModalManagerItem.vue';
import managerModule from '@/store/modules/common/manager.module';
import VModalImportData from '@/components/popup/VModalImportData.vue';
import VTable from '@/components/items/VTable.vue';
import popupModule from '@/store/modules/common/popup.module';
import popup from '@/data/popup.json';

@Component({
  name: 'Manager',
  components: {
    VTable,
    VModalImportData,
    VModalManagerItem,
    VPaginationBar
  }
})
export default class Manager extends Mixin {
  public showModal = false;

  public search = this.$route.query.search_key || '';
  public managerEditing: User | null = null;

  get tableData() {
    return {
      headers: [
        {
          name: 'First Name',
          width: 'width--10',
          order: true,
          query: 'firstName'
        } as TableHeader,
        {
          name: 'Last Name',
          width: 'width--10',
          order: true,
          query: 'lastName'
        } as TableHeader,
        {
          name: 'Job Title',
          width: 'width--15',
          order: true,
          query: 'jobTitle'
        } as TableHeader,
        {
          name: 'Admin</br>User Id',
          width: 'width--10',
          order: true,
          query: 'id'
        } as TableHeader,
        {
          name: 'Email Address</br>(Username)',
          width: 'width--25',
          order: true,
          query: 'email',
          type: 'email'
        } as TableHeader,
        {
          name: 'Organization',
          width: 'width--15',
          order: true,
          query: 'companyName'
        } as TableHeader,
        {
          name: 'Init Password',
          width: 'width--10',
          order: false,
          query: 'initialPassword'
        } as TableHeader
      ],
      property: { edit: true, delete: true, index: true, func: () => '' },
      values: { data: this.managers }
    } as Table;
  }
  public doEdit(user: User | null) {
    this.showModal = true;
    if (user === null) {
      this.managerEditing = {
        id: null,
        firstName: '',
        lastName: '',
        jobTitle: '',
        email: '',
        initialPassword: this.makeInitPassword(6),
        password: '',
        passwordConfirmation: '',
        profilePictureUrl: '',
        companyName: ''
      };
    } else {
      this.managerEditing = user;
    }
  }

  public async doDelete(user: User | null) {
    await Promise.all([
      popupModule.initPopup(popup.deleteManager),
      popupModule.setPayload(user),
      popupModule.setShowPopup(true)
    ]);
  }

  get managers() {
    return managerModule.managers;
  }

  get paging() {
    return managerModule.paging;
  }

  public async doSearch(event: Event) {
    event.preventDefault();
    await this.$router.push({
      path: this.$route.path,
      query: {
        ...this.$route.query,
        search_key: this.search
      }
    });
  }

  public async selectedPage(page) {
    await this.$router.push({
      path: this.$route.path,
      query: {
        ...this.$route.query,
        offset: page
      }
    });
  }

  get query() {
    return this.$route.query;
  }

  @Watch('query', { immediate: true, deep: false })
  public async managerFilter() {
    await managerModule.loadManager(this.$route.query);
  }
}
